export enum IntervalType {
	Today = 1,
	Yesterday = 2,
	Last7Days = 3,
	LastMonth = 4
}

